<template>
  <div v-show="showComponent">
    <a href="#" v-on:click.prevent="showDropDown=!showDropDown">
      <img class="dropdown-title" src="../assets/images/profile-outline.svg"/>
    </a>
    
    <transition name="elements-animation">
      <div v-if="showDropDown" v-on-clickaway="away">
        <ul>
          <li v-for="(viewType, index) in viewTypes" v-bind:key="index">
            <div v-on:click="selectedOption(index)">{{viewType.title}}</div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import firebase from "firebase";
import { mixin as clickaway } from "vue-clickaway";

export default {
  name: "ProfileDropdown",
  mixins: [clickaway],
  created() {
    firebase.auth().onAuthStateChanged(() => {
      var currentUser = firebase.auth().currentUser;
      this.showComponent = currentUser !=  null;

      if(currentUser != null) {
        currentUser.reload();
        this.verified = currentUser.emailVerified;
      }
      // console.log(`Auth state changed for profile Dropdown. \nUser: ${firebase.auth().currentUser}\nShow component: ${this.showComponent}`);
    });
  },
  methods: {
    ...mapActions(["signOutUser"]),
    away() {
      this.showDropDown = false;
    },
    logout() {
      // console.log("Logout");
      this.signOutUser().then(() => {
        this.$router.replace("login");
      });
    },
    selectedOption(index) {
      // console.log("Selected option: " + index);
      // Perform signout or navigation functionality here

      if (this.viewTypes[index].title === "Sign out") {
        // TODO: Give feedback here
        this.logout();
      }

      this.showDropDown = false;
    }
  },
  data() {
    var viewTypes = [
      {
        title: "Sign out"
      }
    ];
    return {
      showDropDown: false,
      viewTypes: viewTypes,
      showComponent: true,
      verified: false
    };
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/styles.scss";

$profile-action-item-width: 200px;

img {
  padding: 7px;
}

ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
  float: right;
}

.border-bottom {
  border-bottom: 2px solid $info-container-color;
}

ul {
  margin-top: 60px;
  margin-right: 20px;
  background-color: $light-grey-color;
  width: $profile-action-item-width;
  border-radius: 5px;
}

li div {
  box-sizing: border-box;
  height: $input-field-height;
  width: $profile-action-item-width;
  text-align: center;
  padding-top: 10px;
  cursor: pointer;
}

li:hover {
  background-color: #ddd;
  color: black;
  border-radius: 5px;
}

a {
  color: white;
  text-decoration: none;
}

.dropdown-title {
  box-sizing: border-box;
  background-color: $light-grey-color;
  border-radius: 25px;
  height: 40px;
  width: 40px;
  text-align: center;
  position: absolute;
  right: 20px;
  fill: red;
  transition: 0.3s;
}

.dropdown-title:hover {
  background-color: $very-light-grey-color;
}

</style>
